import { colors as tenantColors } from "../branding/generated/active-tokens";
import { brand as tenantBrand } from "../branding/generated/brand-manifest";

/**
 * Navigation labels a partner may rename (CRM Branding → App Labels), with the
 * app's own wording. Keys and defaults mirror app-backend's `UI_LABELS`
 * (service/branding/brandingValidation.ts); the wire field is `uiLabels`.
 */
export const DEFAULT_UI_LABELS = {
  navChat: "Chat",
  navShop: "Shop",
  navTrips: "Trips",
  navAccount: "Account",
  bookingTitle: "Booking",
  tabStays: "Stays",
  tabFlights: "Flights",
  tabActivities: "Activities",
  tabFlightsStays: "Flights + Stays",
};

export type UiLabelKey = keyof typeof DEFAULT_UI_LABELS;

export type PartnerBranding = {
  code: string;
  name?: string;

  logoUrl: string;
  logoDarkUrl?: string;
  iconUrl?: string;
  faviconUrl: string;

  primaryColor: string;
  secondaryColor: string;
  accentColor: string;

  /** Only the labels the partner renamed; read through `brandLabel`. */
  labels?: Partial<Record<UiLabelKey, string>>;
};

const tenantAsset = (publicPath: string): string => (process.env.PUBLIC_URL || "") + publicPath;

export const DEFAULT_BRANDING: PartnerBranding = {
  code: "",
  name: tenantBrand.name,
  logoUrl: tenantAsset(tenantBrand.logo.wordmark),
  faviconUrl: "",
  primaryColor: tenantColors.brand.primary,
  secondaryColor: tenantColors.brand.secondary,
  accentColor: tenantColors.brand.tertiary,
};
